import { createApi } from "@reduxjs/toolkit/query/react";
import { transformErrorResponse, transformSuccessResponse } from "../../../../utils/API/responseMiddleware";
import { defaultBaseQuery } from "../../../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../../../utils/API/requestMiddleware";



const ViewEditEventApi = createApi({
    reducerPath: 'ViewEditEventApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getEventDetailList: builder.mutation({
            query: (details) => ({
                url: '/EventManagement/GetEventDetailList',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllDropDownForEventManagement: builder.query({
            query: () => ({
                url: `/EventManagement/GetAllDropDownForEventManagement`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteEventDetailsById: builder.mutation({
            query: (details) => ({
                url: '/EventManagement/DeleteEventDetailById',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})
export const {
    useGetEventDetailListMutation,
    useLazyGetAllDropDownForEventManagementQuery,
    useDeleteEventDetailsByIdMutation

} = ViewEditEventApi;

export default ViewEditEventApi;